<style lang="scss" scoped>
:host {
  background-color: #f6f6f6;
  min-height: 100vh;
}
.trade-container {
  width: 702px;
  margin: 24px auto;
  .sku-container {
    height: 200px;
    padding: 24px;
    margin-bottom: 24px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    position: relative;
    .img-container {
      height: 200px;
      width: 200px;
      margin-right: 16px;
      border: 2px solid #eee;
      box-sizing: border-box;
      overflow: hidden;
      .similar-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .msg-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 200px;
      padding: 24px 16px;
      .brand {
        height: 38px;
        line-height: 38px;
        font-size: 24px;
        color: #262626;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .name {
        flex: 1;
        font-size: 24px;
        color: #262626;
        font-weight: bold;
        line-height: 34px;
        .msg {
          height: 68px;
          font-size: 24px;
          overflow: hidden;
        }
      }
    }
  }

  .trade-list {
    margin-top: 24px;
    // .odd {
    //   background: #ffffff;
    // }
    // .even {
    //   background: #f6f6f6
    // }
    .trade-item {
      height: 82px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      .avator {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        overflow: hidden;
        .img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      .name {
        font-size: 24px;
        color: #999999;
        margin-left: 10px;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .grade-container {
        width: 150px;
        text-align: center;
        .grade {
          display: inline-block;
          height: 28px;
          font-size: 18px;
          color: #8ab1e9;
          line-height: 28px;
          padding: 0 4px;
          box-sizing: border-box;
          border: 1px solid #8ab1e9;
          border-radius: 2px;
          // margin: 10px 4px 0 0;
        }
      }
      .price {
        font-size: 24px;
        color: #2d2d2d;
        width: 150px;
      }
      .time {
        flex: 1;
        text-align: right;
        font-size: 24px;
        color: #999999;
      }
    }
  }
}
.empty-err-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  height: calc(100vh - 0px);
  width: 100vw;
  // background-color: white;
  padding-top: 360px;
  box-sizing: border-box;
  max-height: 100%;
  .status-icon {
    width: 180px;
    height: 100px;
    margin-bottom: 48px;
    object-fit: contain;
  }
  .status-text {
    color: #333;
    font-size: 30px;
    line-height: 42px;
  }
  .status-link {
    color: #999;
    margin-top: 28px;
    font-size: 24px;
    line-height: 34px;
    text-decoration: underline;
  }
  .tips {
    color: #999;
    margin-top: 28px;
    font-size: 24px;
    line-height: 34px;
  }
}
</style>

<template>
  <div class="trade-container">
    <div class="sku-container">
      <div class="img-container">
        <div class="similar-img">
         <img :src="skcInfo.mainPic" />
        </div>
      </div>
      <div class="msg-container">
        <div class="brand">{{skcInfo.brandEnName || '未知品牌'}}</div>
        <div class="name">
          <div class="msg">
            {{skcInfo.productName || '未知产品名称'}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="errStatus == 1" class="empty-err-page-container">
      <!-- 网络异常情况 -->
      <img class="status-icon" src="https://oss.turingsenseai.com/1603512074441638739.png" />
      <span class="status-text">网络异常</span>
      <span class="status-link" @click='getTradeList()'>重新加载</span>
    </div>
    <div v-if="tradeList.length == 0" class="empty-err-page-container">
      <!-- 暂无数据 -->
      <img class="status-icon" src="https://oss.turingsenseai.com/1597910745455776183.png" />
      <span class="tips">很抱歉，没有找到符合条件的交易记录</span>
    </div>
    <div v-if="tradeList.length > 0" class="trade-list">
      <div :class="'trade-item '" v-for="(record, index) in tradeList" :key="index">
        <div class="avator">
          <img class="img" :src="record.avatarHDImage">
        </div>
        <div class="name">{{record.buyerNickname}}</div>
        <div class="grade-container">
          <div class="grade">{{record.newsName}}</div>
        </div>
        <div class="price">￥{{record.actualPrice/100}}</div>
        <div class="time">{{record.orderTime.split(' ')[0]}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSkcInfo, fetchSimilarList, fetchMallProduct, fetchTradeList } from './../../../common/api/ai-picture'

export default {
  data () {
    return {
      tradeList: [],
      skcInfo: {},
      errStatus: 0
    }
  },
  watch: {
    $route () {
      this.skcInfo = JSON.parse(this.$route.query.skcInfo);
      this.getTradeList();
    }
  },
  methods: {
    getTradeList () {
      fetchTradeList({ pageSize: 1000, pageNum: 1, skc: this.skcInfo.skc, state: '8' })
        .then(result => {
          if (result && result.errorCode === 0) {
            this.tradeList = result.itemList;
          } else {
            this.errStatus = 1;
          }
        }, () => {
          this.errStatus = 1;
        })
    }
  },
  mounted () {
    this.skcInfo = JSON.parse(this.$route.query.skcInfo);
    this.getTradeList();
  }
}
</script>
